import * as types from '../types.js';

export default {
	html: `
		<form id="inputs-print-complete-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<p class="fss">Filtros por empresa e período. CSV e Excel trazem todas as colunas; o PDF resume chaves e SEFAZ (use exportação para análise completa).</p>
			<div class="fsb">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label>Data inicial<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Data final<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="fsb">
				<label>Base do período
					<select id="date_basis">
						<option value="created">Data de criação da entrada</option>
						<option value="received">Data de recebimento</option>
					</select>
				</label>
				<label>Armazém (opcional)
					<select id="warehouse_id"><option value="">Todos</option></select>
				</label>
				<label>Status (opcional)
					<select id="status">
						<option value="">Todos</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label>Origem do pedido (opcional)
					<select id="order_type">
						<option value="">Todos</option>
						<option value="I">Pedido de entrada</option>
						<option value="O">Pedido de saída</option>
					</select>
				</label>
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="ic-count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#inputs-print-complete-report',
		init(formset) {
			const root = formset.form?.selector || '#inputs-print-complete-report';
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const stSel = document.querySelector(`${root} #status`);
			const st = types.opt_input_status();
			if (stSel && st?.options) {
				for (const o of st.options) {
					const opt = document.createElement('option');
					opt.value = o.value;
					opt.textContent = o.label;
					stSel.appendChild(opt);
				}
			}
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#date_from' }, types: [] },
		{ properties: { selector: '#date_to' }, types: [] },
		{ properties: { selector: '#date_basis' }, types: [] },
		{ properties: { selector: '#warehouse_id' }, types: [] },
		{ properties: { selector: '#status' }, types: [] },
		{ properties: { selector: '#order_type' }, types: [] },
		{ properties: { selector: '#format' }, types: [] },
		{ properties: { selector: '#ic-count-msg' }, types: [] },
	],
};
